import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { NotificationModel } from "../models/notification.model";
import { PageableResponse } from './../../models/pageable-response.model';


@Injectable({
    providedIn: 'root'

})
export class NotificationsState {

    private static notificationsState: BehaviorSubject<PageableResponse<NotificationModel[]>> = new BehaviorSubject<PageableResponse<NotificationModel[]>>(null);
    static getNotificationsState(): BehaviorSubject<PageableResponse<NotificationModel[]>> { return this.notificationsState; }
    static setNotificationsState(value: PageableResponse<NotificationModel[]>): void { this.notificationsState.next(value); }


    private static socketNotificationState: BehaviorSubject<NotificationModel> = new BehaviorSubject<NotificationModel>(null);
    static getSocketNotificationState(): BehaviorSubject<NotificationModel> { return this.socketNotificationState; }
    static setSocketNotificationState(value: NotificationModel): void { this.socketNotificationState.next(value); }


    private static socketEventState: BehaviorSubject<NotificationModel> = new BehaviorSubject<NotificationModel>(null);
    static getSocketEventState(): BehaviorSubject<NotificationModel> { return this.socketEventState; }
    static setSocketEventState(value: NotificationModel): void { this.socketEventState.next(value); }
}

